var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgDirection = function SvgDirection(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#0F4C3A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.976 5.591 14.61 18.693a.449.449 0 0 1-.851 0l-1.971-5.912a.9.9 0 0 0-.568-.568l-5.912-1.97a.449.449 0 0 1 0-.852l13.102-4.367a.449.449 0 0 1 .567.567"
  })));
};
export default SvgDirection;